module.exports = __webpack_public_path__ + "static/media/dagger.552fd784.svg";